// @flow
import Box from '@mui/material/Box';
import { CardMedia } from '@mui/material';
import InsightAppLogoIcon from '../../assets/insight_app_logo.svg';

const AppLogo = (props: any): React$Node => {
  const AppLogoIcon = InsightAppLogoIcon;
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        height: '200px',
        '&:hover': {
          cursor: 'pointer'
        }
      }}
      {...props}
    >
      <CardMedia
        component="img"
        height="200"
        image={AppLogoIcon}
        alt="Agrolog Logo"
        sx={{ pt: 6, width: 1, height: 'auto' }}
      />
    </Box>
  );
};

export default AppLogo;
